import { SocialAuth } from '@/entities/SocialAuth/ui/SocialAuth'
import './ui/SocialAuth.css'
export default SocialAuth
